import * as React from 'react';
import { SVGProps } from 'react';

const DisputesSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      fill='#9395A1'
      d='M15 9.5V16.5M15 20.5h.01M27.5 10.444V19.556C27.5008 19.819 27.4495 20.079 27.3488 20.322C27.2482 20.565 27.1003 20.785 26.9138 20.97L20.47 27.414C20.285 27.6 20.065 27.748 19.822 27.849C19.579 27.95 19.319 28.001 19.056 28H10.444C10.181 28.001 9.92073 27.95 9.67803 27.849C9.43533 27.748 9.21505 27.6 9.03001 27.414L2.58626 20.97C2.39973 20.785 2.25185 20.565 2.15121 20.322C2.05057 20.079 1.99917 19.819 2 19.556V10.444C1.99917 10.181 2.05057 9.92073 2.15121 9.67803C2.25185 9.43533 2.39973 9.21505 2.58626 9.03001L9.03001 2.58626C9.21505 2.39973 9.43533 2.25185 9.67803 2.15121C9.92073 2.05057 10.181 1.99917 10.444 2H19.556C19.819 1.99917 20.079 2.05057 20.322 2.15121C20.565 2.25185 20.785 2.39973 20.97 2.58626L27.414 9.03001C27.6 9.21505 27.748 9.43533 27.849 9.67803C27.95 9.92073 28.001 10.181 27.5 10.444Z'
      opacity={0.2}
    />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M15 9.5V16.5M15 20.5h.01M27.5 10.444V19.556C27.5008 19.819 27.4495 20.079 27.3488 20.322C27.2482 20.565 27.1003 20.785 26.9138 20.97L20.47 27.414C20.285 27.6 20.065 27.748 19.822 27.849C19.579 27.95 19.319 28.001 19.056 28H10.444C10.181 28.001 9.92073 27.95 9.67803 27.849C9.43533 27.748 9.21505 27.6 9.03001 27.414L2.58626 20.97C2.39973 20.785 2.25185 20.565 2.15121 20.322C2.05057 20.079 1.99917 19.819 2 19.556V10.444C1.99917 10.181 2.05057 9.92073 2.15121 9.67803C2.25185 9.43533 2.39973 9.21505 2.58626 9.03001L9.03001 2.58626C9.21505 2.39973 9.43533 2.25185 9.67803 2.15121C9.92073 2.05057 10.181 1.99917 10.444 2H19.556C19.819 1.99917 20.079 2.05057 20.322 2.15121C20.565 2.25185 20.785 2.39973 20.97 2.58626L27.414 9.03001C27.6 9.21505 27.748 9.43533 27.849 9.67803C27.95 9.92073 28.001 10.181 27.5 10.444Z'
    />
  </svg>
);

export default DisputesSidebar;
